var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.variant,on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('i',{class:['fa', 'fa-' + _vm.icon],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }